<template>
  <div class="main-page-wrapper">
    <MainNavigationSidebar class="main-navigation-sidebar border-right" />
    <div class="d-flex flex-column w-100">
      <AppHeader />
      <transition name="fade" mode="out-in">
        <router-view id="content-window" class="flex-grow-1" />
      </transition>
    </div>
  </div>
</template>

<script>
import MainNavigationSidebar from '../components/navigation/MainNavigationSidebar';
import AppHeader from '../components/navigation/AppHeader';
export default {
  name: 'MainPage',
  components: { AppHeader, MainNavigationSidebar },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';

.main-page-wrapper {
  display: flex;
  height: 100vh;
}
.main-navigation-sidebar {
  transition: all 0.25s ease-in-out;
  background: rgb(244, 245, 247);
  height: 100vh;
  width: 300px;
  min-width: 300px;
  z-index: 300;
  padding: calc(env(safe-area-inset-top) + 0.9rem) calc(env(safe-area-inset-right)) env(safe-area-inset-bottom)
    calc(env(safe-area-inset-left));
}

@media only screen and (max-width: 900px) {
  .main-navigation-sidebar {
    width: 0;
    padding: 0;
    min-width: 0;
    z-index: unset;
  }
}
</style>
